import { useEffect, useState } from "react";
import { ChatList } from "../components/chat-list";
import { ChatContent } from "../components/chat-content";
import { ChatChart, MessageWithCharts } from "../components/chat-chart";
import { useChatHistoryQuery } from "~/shared/api/chat/chat.api";
import { Sheet, SheetContent } from "@racoon/ui";

export const ChatPage = () => {
  const [open, setOpen] = useState(false);
  const [activeChatId, setActiveChatId] = useState<string | null>(null);
  const [isCreatingNewChat, setIsCreatingNewChat] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState<MessageWithCharts | null>(null);
  const [selectedChatTitle, setSelectedChatTitle] = useState<string | null>(null);

  const { data: messages } = useChatHistoryQuery(activeChatId as string, {
    skip: !activeChatId,
  });

  useEffect(() => {
    if (activeChatId && messages?.history) {
      const lastAssistantMsg =
        [...(messages.history as MessageWithCharts[])]
          .reverse()
          .find((msg) => msg.role === "assistant") || null;
      setSelectedMessage(lastAssistantMsg);
    }
  }, [activeChatId, messages?.history]);

  return (
    <div className="lg:p-0 p-4 w-full h-full bg-white lg:bg-transparent overflow-y-auto">
      {activeChatId || isCreatingNewChat ? (
        <ChatContent
          chatId={activeChatId}
          chatTitle={selectedChatTitle}
          setActiveChatId={setActiveChatId}
          selectedMessage={selectedMessage}
          onMessageSelect={(selectedMessage) => {
            setSelectedMessage(selectedMessage);
            setOpen(true);
          }}
          setIsCreatingNewChat={setIsCreatingNewChat}
        />
      ) : (
        <ChatList
          onSelectChat={(chatId, chatTitle) => {
            setActiveChatId(chatId);
            setSelectedChatTitle(chatTitle);
          }}
          onCreateNewChat={setIsCreatingNewChat}
        />
      )}

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent
          side="bottom"
          className="p-0 w-auto rounded-t-lg"
          aria-describedby={undefined}
        >
          <ChatChart message={selectedMessage} onClose={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
    </div>
  );
};
